import axios from "axios";
import pako from "pako";
import { baseURL } from "./urls";

import { POST_FEEDBACK } from "state/modules/feedback/types";

const server = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

export const apiCall = action => async (dispatch, getState) => {
  const { type, payload } = action;

  const matches = /(GET|POST|DELETE|PUT|PATCH)_(.*)/.exec(type);

  if (!matches) return;

  const [, method] = matches;
  const { isConnected } = getState().network;

  const {
    url = "",
    token,
    zip,
    onSuccess = () => {},
    onError,
    onDisconnected,
    onUploadProgress,
    transform = d => d,
  } = payload;
  let { data = null } = payload;

  if (!isConnected) {
    onDisconnected
      ? dispatch(onDisconnected())
      : dispatch({ type: type + "_ERROR", payload: "No network available." });
    return;
  }

  let headers = {};
  if (token) headers.Authorization = `JWT ${token}`;
  if (zip) {
    headers["Content-Type"] = "application/gzip";
    data = pako.gzip(JSON.stringify(data));
  }

  dispatch({ type: type + "_REQUEST" });
  try {
    const { data: response } = await server.request({
      url,
      method,
      data,
      headers,
      onUploadProgress,
    });
    const transformed = transform(response);
    if (type == POST_FEEDBACK) {
      await dispatch(onSuccess(data, response));
    } else {
      await dispatch(onSuccess(transformed));
    }
    dispatch({ type: type + "_SUCCESS" });
  } catch (error) {
    onError
      ? await dispatch(onError(error.response))
      : dispatch({ type: type + "_ERROR", payload: "Something went wrong." });
  }
};

export * from "./urls";
export * from "./fetch-image";
